import './index.scss';
import React, { PropTypes } from 'react';
import classNames from 'classnames';
import { isUndefinedNullOrEmpty } from '../../../js/utils';

const AlertMessage = React.createClass({
    propTypes: {
        type: PropTypes.oneOf(['info', 'fail']).isRequired,
        children: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]).isRequired,
        onDismiss: PropTypes.func
    },
    render: function() {
        const { type, children, onDismiss } = this.props;
        return <div className={classNames('notification', 'notification--block', `notification--${type}`)}>
            <div className="notification--block__inner-container">
                <figure className="notification__icon">
                    <span className={classNames('icon', `icon--${type}`)}></span>
                </figure>
                <div className="notification__body">
                    {children}
                </div>
                {!isUndefinedNullOrEmpty(onDismiss) && <span className="dismiss-btn" onClick={onDismiss}>x</span>}
            </div>
        </div>;
    }
});

export default AlertMessage;


// WEBPACK FOOTER //
// ./src/components/common/AlertMessage/index.jsx